// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-table[data-v-ed8ff0c2] {\n  margin-bottom: 0;\n  max-width: 500px;\n  margin-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
